import {BooleanUDF} from "./UDFs/BooleanUDF";
import {StringUDF} from "./UDFs/StringUDF";
import {NumberUDF} from "./UDFs/NumberUDF";


export class SimulatorConfiguration {
  Enabled: BooleanUDF;
  ButtonControl: BooleanUDF;
  IsFromJsonFile: BooleanUDF;
  JsonFilePath: StringUDF;
  Prefix: StringUDF;
  Interval: NumberUDF;
  InitialDelay: NumberUDF;
  Quantity: NumberUDF;
  IsRssiIncremental: BooleanUDF;
  RssiChangeInterval: NumberUDF;

  get(): any {
    return {
      Enabled: this.Enabled.value,
      ButtonControl: this.ButtonControl.value,
      IsFromJsonFile: this.IsFromJsonFile.value,
      JsonFilePath: this.JsonFilePath.value,
      Prefix: this.Prefix.value,
      Interval: this.Interval.value,
      InitialDelay: this.InitialDelay.value,
      Quantity: this.Quantity.value,
      IsRssiIncremental: this.IsRssiIncremental.value,
      RssiChangeInterval: this.RssiChangeInterval.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/simulator.config.ts